import SaveBar from './saveBar';
import { TitledPaper, TitledPaperProps } from '../titledPaper';

interface TitledPaperWithSaveBarProps extends TitledPaperProps {
  onClickDelete: () => void;
  changeDate?: Date;
}
/**
 * @summary TitledPaper with a ButtonGroup at the bottom
 * @see TitledPaper
 * @see SaveBar
 */
export const TitledPaperWithSaveBar = (props: TitledPaperWithSaveBarProps) => {
  const { onClickDelete, changeDate, children, ...rest } = props;
  return (
    <TitledPaper {...rest}>
      {children}
      <SaveBar onClickDelete={onClickDelete} changeDate={changeDate} />
    </TitledPaper>
  );
};
